<template>
  <g>
    <line
      :x1 ="getThisLineSegmentLength + getXAxisGap"
      :y1 = "0"
      :x2 = "getThisLineSegmentLength + getXAxisGap"
      :y2 = "yPixel"
      :style = "getLineColor"
      class="line"
      ref="line"
      @mousedown="handleMouseDown"
    />
    <g :transform="getTransformXAxisGap">
      <NESWArrows
        r = "13"
        :fill = "getColor"
        pointer-events="visible"
        :transform="transform"
        @mousedown="handleMouseDown"
        @touchstart="handleMouseDown"
        v-if="getInletStatus"
        direction="ew"
      />
      <text
        :x="getThisLineSegmentLength + 28"
        :y="53"
        :fill="getColor"
        class="pipe-line-text"
      >
        {{ getPipeNum }}
      </text>
    </g>
  </g>
</template>

<script>
import { useSegmentStore } from '@/store/SegmentStore';
import { useInputStore } from '@/store/InputStore';
import NESWArrows from '@/components/layout/pipe_editor/pipe_editor_components/NESWArrows';

export default {
  name: 'PipeLine',
  props: [
    'num',
    'segment',
    'parent',
    'transform'
  ],
  components : {
    NESWArrows
  },
  computed: {
    getTransformXAxisGap () {
      return 'translate('+ useInputStore().getXAxisGap + ',0)';
    },
    getPreviousLineSegmentsLength () {
      return useSegmentStore().getPreviousLineSegmentsLength('pipe', this.$props.num);
    },
    getThisLineSegmentLength () {
      const segmentStore = useSegmentStore();
      return (this.getPreviousLineSegmentsLength + segmentStore.getSegmentOfType('pipe', this.$props.num).value) * segmentStore.getMagScale;
    },
    getLineColor () {
      let color = (this.$props.segment.isInlet) ? getComputedStyle(document.body).getPropertyValue('--inlet') : this.$props.segment.color;
      const lineWidth = 3;
      return 'stroke:rgb(' + useSegmentStore().hexToRgb(color) + ');stroke-width:' + lineWidth;
    },
    getColor () {
      return (this.$props.segment.isInlet) ? '#0000ff' : this.$props.segment.color;
    },
    yPixel () {
      const inputStore = useInputStore();
      const height = inputStore.getPressureFlowChartHeight;
      return height - (0.5 * (height - inputStore.getSliderGap) / inputStore.getMarginValueCount);
    },
    getXAxisGap () {
      return useInputStore().getXAxisGap;
    },
    getInletStatus () {
      return !this.$props.segment.isInlet;
    },
    getPipeNum () {
      return this.$props.segment.isInlet ? 'INLET -' +' PIPE ' + (this.$props.num + 1) : 'PIPE ' + (this.$props.num + 1);
    }
  },
  methods: {
    handleMouseDown (e) {
      this.parent.handleMouseDown(e);
    },
  }
};
</script>

<style scoped>
.pipe-line-circle {
  cursor: ew-resize;
}
.pipe-line-text {
  text-align: center;
  writing-mode: vertical-lr;
  font-weight: 800;
  font-family: "Heebo", sans-serif;
  font-size: 80%;
  letter-spacing: .02em;
}
</style>